<template>
  <div class="form-base">
    <div class="form-tabs">
      <button
        @click="activeTab = 'signin'"
        :class="{ active: activeTab === 'signin' }"
        class="tab-button"
      >
        Sign In
      </button>
      <button
        @click="activeTab = 'signup'"
        :class="{ active: activeTab === 'signup' }"
        class="tab-button"
      >
        Sign Up
      </button>
    </div>

    <div v-if="activeTab === 'signin'" class="auth-form">
      <h2>Welcome Back</h2>

      <!-- Google Sign In -->
      <button @click="signInWithGoogle" class="google-auth-button" type="button" :disabled="signingInWithGoogle">
        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
          <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
          <path fill="#FF3D00" d="m6.306 14.691 6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
          <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
          <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
        </svg>
        {{ signingInWithGoogle ? 'Signing in with Google...' : 'Continue with Google' }}
      </button>

      <div class="form-divider">
        <span>or</span>
      </div>

      <form @submit.prevent="signIn">
        <div class="form-group">
          <label for="signin-email" class="form-label">Email</label>
          <input
            v-model="signInForm.email"
            type="email"
            id="signin-email"
            class="input-base"
            required
            placeholder="Enter your email"
          >
        </div>
        <div class="form-group">
          <label for="signin-password" class="form-label">Password</label>
          <input
            v-model="signInForm.password"
            type="password"
            id="signin-password"
            class="input-base"
            required
            placeholder="Enter your password"
          >
        </div>
        <button type="submit" class="form-button form-button-primary" :disabled="signingIn">
          {{ signingIn ? 'Signing In...' : 'Sign In' }}
        </button>
      </form>
    </div>

    <div v-else class="auth-form">
      <h2>Join Socialhood</h2>
      
      <!-- Google Sign Up -->
      <button @click="signInWithGoogle" class="google-auth-button" type="button" :disabled="signingInWithGoogle">
        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
          <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
          <path fill="#FF3D00" d="m6.306 14.691 6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
          <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
          <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
        </svg>
        {{ signingInWithGoogle ? 'Signing up with Google...' : 'Continue with Google' }}
      </button>
      
      <div class="form-divider">
        <span>or</span>
      </div>
      
      <form @submit.prevent="signUp">
        <div class="form-group">
          <label for="signup-email" class="form-label">Email</label>
          <input
            v-model="signUpForm.email"
            type="email"
            class="input-base" 
            id="signup-email" 
            required 
            placeholder="Enter your email"
          >
        </div>
        <div class="form-group">
          <label for="signup-password">Password</label>
          <input 
            v-model="signUpForm.password" 
            type="password" 
            id="signup-password" 
            required 
            placeholder="Create a password"
            minlength="8"
          >
        </div>
        <div class="form-group">
          <label for="signup-confirm">Confirm Password</label>
          <input 
            v-model="signUpForm.confirmPassword" 
            type="password" 
            id="signup-confirm" 
            required 
            placeholder="Confirm your password"
          >
        </div>
        <button type="submit" class="auth-button" :disabled="signingUp">
          {{ signingUp ? 'Creating Account...' : 'Create Account' }}
        </button>
      </form>
    </div>

    <div v-if="confirmationRequired" class="confirmation-form">
      <h3>Confirm Your Email</h3>
      <p>Please enter the confirmation code sent to your email:</p>
      <form @submit.prevent="confirmSignUp">
        <div class="form-group">
          <label for="confirmation-code">Confirmation Code</label>
          <input 
            v-model="confirmationCode" 
            type="text" 
            id="confirmation-code" 
            required 
            placeholder="Enter 6-digit code"
          >
        </div>
        <button type="submit" class="auth-button">Confirm Account</button>
      </form>
    </div>

    <div v-if="error" class="error-message">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { signIn as amplifySignIn, signUp as amplifySignUp, confirmSignUp as amplifyConfirmSignUp, signInWithRedirect } from 'aws-amplify/auth';
import { useKeyboardManagement } from '../composables/useKeyboardManagement.js';

export default {
  name: 'AuthForms',
  props: {
    initialTab: {
      type: String,
      default: 'signin'
    }
  },
  emits: ['auth-success'],
  setup() {
    // Mobile keyboard management
    useKeyboardManagement();

    return {};
  },
  data() {
    return {
      activeTab: this.initialTab,
      signingIn: false,
      signingUp: false,
      signingInWithGoogle: false,
      confirmationRequired: false,
      error: null,
      signInForm: {
        email: '',
        password: ''
      },
      signUpForm: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      confirmationCode: '',
      pendingUser: null
    }
  },
  watch: {
    initialTab(newTab) {
      this.activeTab = newTab
    }
  },
  methods: {
    async signInWithGoogle() {
      if (this.signingInWithGoogle) return;
      
      this.signingInWithGoogle = true;
      this.error = null;
      
      try {
        await signInWithRedirect({
          provider: 'Google'
        });
        // The redirect will handle the rest, user will be redirected back after authentication
      } catch (error) {
        this.error = error.message || 'Failed to sign in with Google';
        console.error('Google sign in error:', error);
      } finally {
        this.signingInWithGoogle = false;
      }
    },

    async signIn() {
      if (this.signingIn) return;
      
      this.signingIn = true;
      this.error = null;

      try {
        const user = await amplifySignIn({
          username: this.signInForm.email,
          password: this.signInForm.password
        });
        
        this.signInForm = { email: '', password: '' };
        this.$emit('auth-success', user);
      } catch (error) {
        this.error = error.message || 'Failed to sign in';
        console.error('Sign in error:', error);
      } finally {
        this.signingIn = false;
      }
    },

    async signUp() {
      if (this.signingUp) return;
      
      if (this.signUpForm.password !== this.signUpForm.confirmPassword) {
        this.error = 'Passwords do not match';
        return;
      }

      this.signingUp = true;
      this.error = null;

      try {
        const result = await amplifySignUp({
          username: this.signUpForm.email,
          password: this.signUpForm.password,
          options: {
            userAttributes: {
              email: this.signUpForm.email
            }
          }
        });

        if (result.isSignUpComplete) {
          this.$emit('auth-success', result.user);
        } else {
          this.confirmationRequired = true;
          this.pendingUser = result.user;
        }
        
        this.signUpForm = { email: '', password: '', confirmPassword: '' };
      } catch (error) {
        this.error = error.message || 'Failed to create account';
        console.error('Sign up error:', error);
      } finally {
        this.signingUp = false;
      }
    },

    async confirmSignUp() {
      try {
        const result = await amplifyConfirmSignUp({
          username: this.signUpForm.email || this.pendingUser?.username,
          confirmationCode: this.confirmationCode
        });

        this.confirmationRequired = false;
        this.confirmationCode = '';
        
        // Auto sign in after confirmation
        if (this.signUpForm.email && this.signUpForm.password) {
          await this.signIn();
        } else {
          this.$emit('auth-success', this.pendingUser);
        }
      } catch (error) {
        this.error = error.message || 'Failed to confirm account';
        console.error('Confirmation error:', error);
      }
    }
  }
}
</script>

<style scoped>
/* AuthForms-specific styles only - most form styles handled by global utilities */

.auth-form h2 {
  text-align: center;
  margin-bottom: var(--spacing-xl);
  color: var(--color-text-dark);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.confirmation-form {
  background-color: var(--color-background-light);
  padding: var(--spacing-xl);
  border-radius: var(--border-radius-md);
  margin-top: var(--spacing-lg);
}

.confirmation-form h3 {
  margin-bottom: var(--spacing-sm);
  color: var(--color-text-dark);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.confirmation-form p {
  margin-bottom: var(--spacing-lg);
  color: var(--color-text-medium);
}

.error-message {
  background-color: var(--color-danger-light);
  color: var(--color-danger);
  padding: var(--spacing-sm);
  border-radius: var(--border-radius-md);
  margin-top: var(--spacing-lg);
  text-align: center;
  border: 1px solid var(--color-danger);
}
</style>